export default "__VITE_ASSET__BpFKxXWY__"